module.exports = __webpack_public_path__ + "static/media/Rubick.930f58af.png";